import styled, { css } from 'styled-components'

export const StyledAddEventButton = styled.button<{ visible: boolean }>`
    background-color: #37a3ef;
    padding: 5px;
    border: none;
    border-radius: 3px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 12px;
    right: 8px;
    z-index: 200;
    color: white;

    i {
        font-size: 10px;
        margin-right: 5px;
    }

    strong {
        font-size: 13px;
        font-weight: 600;
    }

    ${({ visible }) => {
        const transitionTime = 0.15

        return css`
            transition: visibility ${transitionTime}s, opacity ${transitionTime}s;
            ${visible
                ? css`
                      visibility: visible;
                      opacity: 1;
                  `
                : css`
                      visibility: hidden;
                      opacity: 0;
                  `}
        `
    }}
`

export const ChartContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    max-height: 30px;
    min-height: 20px;
`

export const ChartTitle = styled.div`
    width: 100%;
    text-align: center;
    margin-top: 8px;
    padding-bottom: 1px;

    span {
        padding: 0px 5px;
        color: var(--gray-800);
        font-size: 9px !important;
        font-weight: 700;
    }
`
interface ButtonsContainerProps {
    tootipLeftPosition: number | string
    tooltipTopPosition: number | string
    pinLeftPosition?: number | string
    pinRightPosition?: number | string
}
export const ButtonsContainer = styled.div<ButtonsContainerProps>`
    position: absolute;
    display: flex;
    justify-content: center;
    z-index: 1000;
    top: ${props => props.tooltipTopPosition}px;
    left: ${props => props.tootipLeftPosition}px;
    transform: translateX(-50%);

    &.create-tooltip {
        background-color: var(--gray-800);
        margin-top: 7px;
        padding: 1rem;
        left: initial;
        transform: ${props => `translate(${+props.tootipLeftPosition}px)`};

        top: ${props => Number(props.tooltipTopPosition) - 10}px;

        display: flex;
        flex-direction: column;
        gap: 1rem;
        text-align: center;

        height: auto;
        width: fit-content;
        border-radius: 2px;

        p {
            font-size: 11px;
            color: var(--gray-400);
        }

        .tooltip-first-infos {
            p {
                color: var(--gray-500);
                font-family: 'SourceSansPro-Regular';
                font-style: normal;
                font-size: 13px;
                line-height: 17px;

                #hour {
                    color: var(--gray-0);
                    font-family: 'SourceSansPro-Semibold';
                }
            }
        }

        .tooltip-father-infos {
            border-top: 1px solid var(--gray-700);
            padding-top: 1rem;

            .tooltip-father-type {
                color: var(--gray-500);
            }

            .tooltip-father-dates {
                display: flex;
                display: flex;
                justify-content: center;
                gap: 0.5rem;

                p {
                    color: var(--gray-500);
                }
            }
        }

        &:before {
            content: '';
            display: block;
            width: 0px;
            height: 0px;
            position: absolute;
            border-top: 8px solid transparent;
            border-bottom: 8px solid transparent;
            border-right: 8px solid var(--gray-700);
            left: ${props => props.pinLeftPosition};
            right: ${props => props.pinRightPosition};
            top: -12px;
            transform: rotate(90deg);
        }

        p {
            color: ${({ theme }) => theme['text-header']};
            margin: 0;
        }
    }

    .btn-wrapper {
        display: flex;
        flex-direction: column;
        gap: 6px;
        -webkit-box-align: center;
        align-items: center;
        justify-content: center;
        background: var(--gray-800);
        padding: 8px;
        border-radius: 3px;

        span {
            color: var(--gray-500);
            font-weight: 700;

            strong {
                color: var(--gray-0);
            }
        }
    }

    .btn-content {
        display: flex;
        padding-top: 2px;
        gap: 20px;

        i:hover {
            color: var(--blue-300);
        }
    }

    .toogler {
        position: absolute;
        top: -17px;
        font-size: 27px;
        color: ${({ theme }) => theme['gray-800']};
        cursor: initial;
        &:hover {
            color: ${({ theme }) => theme['gray-800']};
        }
    }

    i {
        cursor: pointer;
        color: #37a3ef;
        font-size: 17px;

        &:hover {
            color: #fff;
        }
    }
`

export const Divisor = styled.div`
    width: 100%;
    height: 1px;

    background-color: var(--gray-700);
`

export const DeleteConfirmationModalContainer = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

export const ModalContent = styled.div`
    border-radius: 3px;

    background: var(--gray-0);

    header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 24px;

        border-bottom: 1px solid var(--gray-400);

        .icon-txt {
            display: flex;
            align-items: center;
            gap: 8px;

            i {
                font-size: 16px;

                color: var(--red-700);
            }

            span {
                font-size: 18px;

                color: var(--red-700);
            }
        }
        .close-btn {
            font-size: 14px;
            cursor: pointer;

            color: var(--gray-800);

            transition: opacity 0.2s;

            &:hover {
                opacity: 0.8;
            }
        }
    }
    main {
        width: 384px;
        padding: 24px;

        background: var(--gray-200);

        .warning-txt {
            display: flex;
            flex-direction: column;

            span,
            strong {
                font-size: 13px;
                line-height: 27px;

                color: var(--gray-800);
            }
        }

        .delete-option-content {
            display: flex;
            flex-direction: column;
            gap: 12px;

            .delete-options {
                display: flex;
                align-items: center;
                height: 16px;
                gap: 4px;

                input {
                    width: 16px;
                    height: 16px;
                    border-color: var(--gray-500);

                    :after {
                        width: 8px;
                        height: 8px;
                        top: 3px;
                        left: 3px;
                    }
                }

                label {
                    padding-bottom: 0;

                    font-family: 'SourceSansPro-Regular';
                    font-weight: 400;

                    color: var(--gray-600);
                }
            }

            .warning-txt {
                margin-top: 8px;
                gap: 8px;

                span,
                strong {
                    line-height: 16px;
                }
            }
        }
    }

    footer {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px;

        border-top: 1px solid var(--gray-400);

        button {
            padding: 8px 24px;
            border-radius: 3px;
            border: none;

            font-size: 15px;
            font-weight: 600;

            background: transparent;
        }

        .btn-confirm {
            color: #ffffff;
            background: var(--red-500);

            transition: filter 0.2s;

            &:hover {
                filter: brightness(0.9);
            }
        }

        .btn-confirm-changes {
            color: #ffffff;
            background: var(--blue-500);

            transition: filter 0.2s;

            &:hover {
                filter: brightness(0.9);
            }
        }

        .btn-cancel {
            color: var(--gray-1000);
            border: 1px solid var(--gray-500);

            transition: background-color 0.2s;

            &:hover {
                background-color: #b6babe;
            }
        }
    }
`

export const ErrorNotificationWrapper = styled.div`
    display: flex;
    gap: 8px;

    i {
        font-size: 1.625rem;
        font-weight: 500;
    }
    .track-disabled-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
        p {
            font-size: 1.4rem;
            margin: 0;
            color: #fff;
        }

        p:first-child {
            font-size: 1.6rem;
            font-weight: 900;
            color: #fff;
        }
    }
`
export const GlobalNotificationWrapper = styled.div`
    display: flex;
    gap: 8px;

    i {
        font-size: 17px;
        font-weight: 500;
        color: #fff;
    }
    .notification-content-wrapper {
        display: flex;
        flex-direction: column;
        gap: 4px;
        p {
            font-size: 15px;
            margin: 0;
            color: #fff;
        }

        p:first-child {
            font-size: 17px;
            font-weight: 900;
            color: #fff;
        }
    }
`
